import { request } from './ChartConfigService';

// Config del modo "Análisis Profundo" del chat (prompts del planificador,
// investigador y sintetizador, modelos y límites). Vive en
// whisperbi-agent-management-strands (billing-admin/app.py, GET/PUT
// /analysis-config, solo root), en la misma API que /chart-config.
const AnalysisConfigService = {
  async getConfig() {
    return request('/analysis-config', { method: 'GET' });
  },
  async upsertConfig(payload) {
    return request('/analysis-config', { method: 'PUT', body: JSON.stringify(payload) });
  }
};

export default AnalysisConfigService;
